const REDDIT_SOURCE_PREFIX = "reddit";
const REDDIT_SOURCE_PATTERN = /^reddit:([^:]+):([a-z0-9]+)$/i;

export function normalizeRedditSubreddit({
  subreddit,
}: {
  subreddit: string;
}): string {
  return subreddit.trim().replace(/^r\//i, "").toLowerCase();
}

export function normalizeRedditPostId({ postId }: { postId: string }): string {
  return postId.trim().replace(/^t3_/i, "").toLowerCase();
}

export function createRedditSourceId({
  postId,
  subreddit,
}: {
  subreddit: string;
  postId: string;
}): string {
  return `${REDDIT_SOURCE_PREFIX}:${normalizeRedditSubreddit({ subreddit })}:${normalizeRedditPostId({ postId })}`;
}

export function parseRedditSourceId({ sourceId }: { sourceId: string }): {
  subreddit: string;
  postId: string;
} | null {
  const match = sourceId.match(REDDIT_SOURCE_PATTERN);
  if (!match) {
    return null;
  }

  return {
    subreddit: normalizeRedditSubreddit({ subreddit: match[1] ?? "" }),
    postId: normalizeRedditPostId({ postId: match[2] ?? "" }),
  };
}

export function buildRedditPostUrl({
  postId,
  subreddit,
}: {
  subreddit: string;
  postId: string;
}): string {
  const normalizedSubreddit = normalizeRedditSubreddit({ subreddit });
  const normalizedPostId = normalizeRedditPostId({ postId });
  return `https://www.reddit.com/r/${encodeURIComponent(normalizedSubreddit)}/comments/${encodeURIComponent(normalizedPostId)}/`;
}

export function buildRedditSubredditUrl({
  subreddit,
}: {
  subreddit: string;
}): string {
  const normalizedSubreddit = normalizeRedditSubreddit({ subreddit });
  return `https://www.reddit.com/r/${encodeURIComponent(normalizedSubreddit)}/`;
}
